<template>
  <form
    method="post"
    @submit.prevent="$emit('search', searchQuery)"
  >
    <div class="input-group">
      <label for="search-field"></label>
      <input
        id="search-field"
        v-model="searchQuery"
        class="form-control form-check-label"
        :class="{'form-control-lg': !small}"
        :placeholder="$t(placeholder)"
      />
      <div class="input-group-append">
        <button
          v-if="resetButtonShown"
          class="btn btn-secondary mr-2"
          type="button"
          @click="resetSearch"
          id="search-field-reset"
        >
          {{ $t('word.reset') }}
        </button>
        <button
          class="btn btn-info"
          type="submit"
          id="search-field-submit"
        >
          <i class="fa fa-search navbar-icon align-middle"></i>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SearchField',
  props: {
    small: {
      type: Boolean,
      default() {
        return false;
      },
    },
    placeholder: {
      type: String,
      default() {
        return 'word.search';
      },
    },
    showReset: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    resetButtonShown() {
      if (this.showReset) {
        return true;
      }
      return !!this.searchQuery;
    },
  },
  methods: {
    resetSearch() {
      this.searchQuery = '';
      this.$emit('reset');
    },
  },
};
</script>
